import axios from 'axios';
import queryString from 'query-string';
import actions from '../actions/userRole';

export default {
	namespaced: true,
	state: {
		entities: [],
		links: [],
		paginationMetadata: {},
	},
	mutations: {
		[actions.SET_DATA]: (state, data) => {
			state.links = data.links;
			state.entities = data.entities;
			state.paginationMetadata = data.paginationMetadata;
		},
		[actions.REMOVE_DATA]: (state) => {
			state.links = [];
			state.entities = [];
			state.paginationMetadata = {};
		},
	},
	actions: {
		[actions.GET_USERS_ROLES]: async (
			{ commit, rootState },
			{ organizationId, queryParameters }) => {
			try {
				commit(actions.REMOVE_DATA);

				const link = rootState.root.links.find(x => x.rel === 'user_roles' && x.templated);

				const queryTemplatePos = link.href.indexOf('{?');
				const queryTemplate = link.href.substring(queryTemplatePos, link.href.length);

				const href = link.href
					.replace('{organizationId}', organizationId)
					.replace(queryTemplate, `?${queryString.stringify(queryParameters)}`);

				const response = await axios.get(href);

				const { data } = response;

				data.entities.forEach((entity) => {
					entity.id = `${entity.userId}${entity.roleId}${entity.organizationId}`;
				});

				commit(actions.SET_DATA, data);
			} catch (error) {
				throw error;
			}
		},
		[actions.FETCH_USERS_ROLES]: async ({ commit }, link) => {
			try {
				commit(actions.REMOVE_DATA);

				const response = await axios.get(link.href);

				const { data } = response;

				data.entities.forEach((entity) => {
					entity.id = `${entity.userId}${entity.roleId}${entity.organizationId}`;
				});

				commit(actions.SET_DATA, data);
			} catch (error) {
				throw error;
			}
		},
		[actions.FETCH_USERS_ROLES_ORGANIZATIONS]: async ({ rootState }, organizationId) => {
			let organizations = [];

			try {
				const link = rootState.root.links
					.find(x => x.rel === 'organizations_from_user_roles_for_selectors' && x.templated);

				const href = link.href
					.replace('{organizationId}', organizationId);

				const response = await axios.get(href);

				const { data } = response;

				organizations = data;
			} catch (error) {
				throw error;
			}

			return organizations;
		},
		[actions.CREATE_NEW_USER_ROLE]: async (context, { newUserRole, link }) => {
			try {
				await axios.post(link.href, newUserRole);
			} catch (error) {
				throw error;
			}
		},
		[actions.DELETE_USER_ROLES]: async (context, { userRoles, link }) => {
			try {
				await axios.put(link.href, userRoles);
			} catch (error) {
				throw error;
			}
		},
		[actions.UPDATE_USER_ROLE]: async (context, { status, link }) => {
			try {
				const patch = [
					{
						op: 'replace',
						path: '/status',
						value: status,
					},
				];

				await axios.patch(
					link.href,
					patch, {
						headers: { 'Content-Type': 'application/json-patch+json' },
					},
				);
			} catch (error) {
				throw error;
			}
		},
	},
	getters: {
		Entities: state => state.entities,
		Links: state => state.links,
		Pagination: state => state.paginationMetadata,
	},
};
